import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Suggestions = _resolveComponent("Suggestions")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_icon, {
                icon: "$oss-chevron-left",
                class: "back_btn",
                size: "large",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'companyactivities-table' })))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "11"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, _toDisplayString(_ctx.name), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.description), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-5" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("p", null, "Validez les comptes comptables", -1)),
              (_ctx.activity)
                ? (_openBlock(), _createBlock(_component_Suggestions, {
                    key: 0,
                    suggestions: _ctx.activity.suggestions,
                    onChangeStatus: _ctx.onChangeStatus
                  }, null, 8, ["suggestions", "onChangeStatus"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}